module.exports = __webpack_public_path__ + "img/anydesk.a5f4de33.svg";